import { mapIds, mapObjectize } from 'cityads-v3/utils/apiUtils';
import { ensureArray } from 'cityads-v3/utils/arrayUtils';

import {
  GET_LOST_ORDERS,
  GET_LOST_ORDERS_SUCCESS,
  GET_LOST_ORDERS_FAIL,

  GET_LOST_ORDERS_STATUSES,
  GET_LOST_ORDERS_STATUSES_SUCCESS,
  GET_LOST_ORDERS_STATUSES_FAIL,

  SAVE_LOST_ORDER,
  SAVE_LOST_ORDER_SUCCESS,
  SAVE_LOST_ORDER_FAIL,

  DELETE_LOST_ORDER,
  DELETE_LOST_ORDER_SUCCESS,
  DELETE_LOST_ORDER_FAIL,

  SET_EDIT_FORM,
  SET_EDIT_FORM_ERRORS,
  CLEAR_EDIT_FORM,
} from "../actions/lostOrders";

const initialState = {
  lostOrders: [],
  lostOrdersById: {},
  totalLostOrders: 0,
  statuses: [],
  statusesById: {},

  editForm: {},
  editFormErrors: {},
  isDeletingLostOrder: false,
  isDeletedLostOrder: false,
  isEditFormSubmited: false,
  isEditFormSubmitting: false,

  isLoading: false,
  isLoaded: false,
  isLoadingStatuses: false,
  isLoadedStatuses: false,

};

function parseLostOrder(item) {
  return {
    ...item,
    id: +item.id,
    traffic_channel_id: +item.traffic_channel_id,
    offer_id: +item.offer_id,
    order_currency_id: +item.order_currency_id,
    status_id: +item.status_id,
  }
}

export default function lostOrders(state = initialState, action = {}) {
  switch (action.type) {
    case GET_LOST_ORDERS:
      return {
        ...state,
        isLoading: true,
      }

    case GET_LOST_ORDERS_SUCCESS:
      const lostOrders = ensureArray(action.response.lostOrder || []).map(parseLostOrder);
      const lostOrdersById = mapObjectize(lostOrders);
      return {
        ...state,
        lostOrders: mapIds(lostOrders),
        lostOrdersById: {
          ...state.lostOrdersById,
          ...lostOrdersById
        },
        totalLostOrders: action.response.meta && action.response.meta.total,
        isLoading: false,
        isLoaded: true,
      }

    case GET_LOST_ORDERS_FAIL:
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
      }

    case GET_LOST_ORDERS_STATUSES:
      return {
        ...state,
        isLoadingStatuses: true,
        isLoadedStatuses: false,
      }

    case GET_LOST_ORDERS_STATUSES_SUCCESS:
      const statuses = ensureArray(action.response.lostOrderStatus.map(item => ({
        ...item,
        id: +item.id
      })));
      const statusesById = mapObjectize(statuses);
      return {
        ...state,
        statuses: statuses.map(item => item.id),
        statusesById,
        isLoadingStatuses: false,
        isLoadedStatuses: true,
      }

    case GET_LOST_ORDERS_STATUSES_FAIL:
      return {
        ...state,
        isLoadingStatuses: false,
        isLoadedStatuses: false,
      }

    case SAVE_LOST_ORDER:
      return {
        ...state,
        isEditFormSubmited: false,
        isEditFormSubmitting: true,
      }

    case SAVE_LOST_ORDER_SUCCESS:
      return {
        ...state,
        isEditFormSubmited: true,
        isEditFormSubmitting: false,

        lostOrders: [
          ...(action.additional.isNew ? [+action.response.lostOrder.id]: []),
          ...state.lostOrders,
        ],
        lostOrdersById: {
          ...state.lostOrdersById,
          [action.response.lostOrder.id]: parseLostOrder({ ...action.response.lostOrder })
        },
        totalLostOrders: action.additional.isNew ? state.totalLostOrders + 1 : state.totalLostOrders,
      }

    case SAVE_LOST_ORDER_FAIL:
      const errors = action.response.data && action.response.data.form_errors;
      return {
        ...state,
        isEditFormSubmited: false,
        isEditFormSubmitting: false,

        editFormErrors: errors ? Object.keys(errors).reduce((prev, next) => ({
          ...prev,
          [next]: errors[next] && errors[next].length ? errors[next].join(', ') : false
        }), {}) : initialState.editFormErrors
      }


    case SET_EDIT_FORM:
      return {
        ...state,
        editForm: {
          ...state.editForm,
          ...action.form
        },
        editFormErrors: {
          ...state.editFormErrors,
          ...(
            Object.keys(action.form).reduce((prev, next) => ({
              ...prev,
              [next]: !action.form[next]
            }), {})
          )
        }
      }

    case DELETE_LOST_ORDER:
      return {
        ...state,
        isDeletingLostOrder: true,
        isDeletedLostOrder: false,

      }
    case DELETE_LOST_ORDER_SUCCESS:
      const newLostOrders = [...state.lostOrders];
      newLostOrders.splice(newLostOrders.indexOf(action.additional.id), 1);
      return {
        ...state,
        isDeletingLostOrder: false,
        isDeletedLostOrder: true,
        lostOrders: newLostOrders,
        totalLostOrders: state.totalLostOrders - 1
      }
    case DELETE_LOST_ORDER_FAIL:
      return {
        ...state,
        isDeletingLostOrder: false,
        isDeletedLostOrder: false,
      }

    case SET_EDIT_FORM_ERRORS:
      return {
        ...state,
        editFormErrors: {
          ...state.editFormErrors,
          ...action.form
        }
      }

    case CLEAR_EDIT_FORM:
      return {
        ...state,
        editForm: initialState.editForm,
        editFormErrors: initialState.editFormErrors,
        isEditFormSubmited: initialState.isEditFormSubmited,
        isEditFormSubmitting: initialState.isEditFormSubmitting,
        isDeletedLostOrder: initialState.isDeletedLostOrder,
        isDeletingLostOrder: initialState.isDeletingLostOrder,
      }

    default:
      return state;
  }
}
